import React from 'react';

import { NOTIFICATION } from '../../Pages';

export default {
  path: NOTIFICATION.pageURL,
  async action() {
    const { default: NotificationManager } =
      await import('./NotificationManager');
    return <NotificationManager key={'list'} />;
  },
};
